var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreeState(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16.6667,
    height: 15.0004,
    viewBox: "0 0 16.6667 15.0004",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.83333 14.1668L1.29417 11.8968C1.01189 11.7558 0.833502 11.4674 0.833333 11.1518V2.18185C0.833488 1.89315 0.983057 1.6251 1.22866 1.47335C1.47427 1.32161 1.78091 1.3078 2.03917 1.43685L5.83333 3.33352M5.83333 14.1668L10.8333 11.6668M5.83333 14.1668V3.33352M10.8333 11.6668L14.6275 13.5635C14.8858 13.6926 15.1924 13.6788 15.438 13.527C15.6836 13.3753 15.8332 13.1072 15.8333 12.8185V3.84852C15.8332 3.53296 15.6548 3.24457 15.3725 3.10352L10.8333 0.833516M10.8333 11.6668V0.833516M10.8333 0.833516L5.83333 3.33352",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeState);
export default __webpack_public_path__ + "static/media/tree-state.61fc351f595a189c5ed2289b73ab9879.svg";
export { ForwardRef as ReactComponent };